module.exports = require("events");


//////////////////
// WEBPACK FOOTER
// external "events"
// module id = 322
// module chunks = 0